import { EAppStep } from '@/typescript/enums/EAppStep';
import { EProductFormat } from '@/typescript/enums/EProductFormat';
import { WFabricWorld } from '@/littleWedding/WFabricWorld';
import { defineStore } from 'pinia';
import { computed, ref, type Ref } from 'vue';
import type { IField } from '@/typescript/interfaces/IField';
import type { TSides } from '@/typescript/interfaces/TSide';
import type { IProductImage } from '@/typescript/interfaces/IProductImage';
import type { IFont } from '@/typescript/interfaces/IFont';
import type { IAppConfig } from '@/obsidianApi/api.doc';
import type { IProduct } from '@/typescript/interfaces/IProduct';

const useConfigStore = defineStore('config', () => {
    const isMobile = ref(false);
    const isAppLoading = ref(true);
    const currentStep = ref(EAppStep.TEMPLATES);
    const fonts = ref<IFont[]>([]);
    const token = ref('');
    const userName = ref('');
    const isAdmin = ref(false);
    const isAnimated = ref(false);
    const isZoomed = ref(true);
    const isColorsLocked = ref(false);
    const fZoom = ref(1);
    const zoomLvl3d: Ref<0 | 1 | 2> = ref(0);
    const lang = ref<'en_En' | 'fr_Fr'>('fr_Fr');
    const productType = ref<IAppConfig['product_type']>('cup_33');
    const productFormat = ref<IProduct['format']>(EProductFormat.RECTO_VERSO);
    const isStoreInitialized = ref(false);
    const displayGrid = ref(false);
    const isBATModalVisible = ref(false);
    const width = ref<IProduct['width']>(0);
    const height = ref<IProduct['height']>(0);
    const projectId = ref<string>();
    const isProductEdition = ref(false);
    const productId = ref(0);
    const productImages = ref<IProductImage[]>([]);
    const cutpathFieldList = ref<IField[]>([]);
    const currentSide = ref<TSides>('recto');
    const productName = ref('');
    const printWidth = ref(0);
    const printHeight = ref(0);

    const isCup = computed(() => {
        return productType.value === 'cup_33' || productType.value === 'cup_50';
    });

    const wFabricWorldInstanceRecto = ref<WFabricWorld>(new WFabricWorld());
    const wFabricWorldInstanceVerso = ref<WFabricWorld>();

    return {
        currentStep,
        displayGrid,
        fonts,
        fZoom,
        height,
        isAppLoading,
        isAnimated,
        isAdmin,
        isBATModalVisible,
        isMobile,
        isStoreInitialized,
        isZoomed,
        lang,
        productFormat,
        productType,
        token,
        userName,
        width,
        projectId,
        zoomLvl3d,
        isProductEdition,
        productId,
        productImages,
        cutpathFieldList,
        currentSide,
        isColorsLocked,
        isCup,
        productName,
        printHeight,
        printWidth,
        wFabricWorldInstanceRecto,
        wFabricWorldInstanceVerso,
    };
});

export { useConfigStore };
